import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './RecommendedField.styles';

export enum Recommended {
  Yes = 'yes',
  No = 'no'
}

export interface RecommendedFieldProps {
  error?: boolean;
  helperText?: string;
  name?: string;
  onChange?: (value: Recommended) => void;
}

export function RecommendedField({
  error,
  helperText,
  name,
  onChange
}: RecommendedFieldProps) {
  const slots = styles();

  const t = useTranslations('review.form.recommended');

  const [recommended, setRecommended] = useState<Recommended>();

  return (
    <div className={slots.base()}>
      <div className={slots.buttons()}>
        <UiKitButtonBase
          className={slots.button({ active: recommended === Recommended.Yes })}
          color={recommended === Recommended.Yes ? 'default' : 'secondary'}
          onClick={() => {
            setRecommended(Recommended.Yes);
            onChange?.(Recommended.Yes);
          }}
        >
          {t('yes')}
        </UiKitButtonBase>
        <UiKitButtonBase
          className={slots.button({
            active: recommended === Recommended.No
          })}
          color={recommended === Recommended.No ? 'default' : 'secondary'}
          onClick={() => {
            setRecommended(Recommended.No);
            onChange?.(Recommended.No);
          }}
        >
          {t('no')}
        </UiKitButtonBase>
      </div>
      <input
        type="hidden"
        name={name}
        value={recommended ?? ''}
      />
      {error && <div className={slots.error()}>{helperText}</div>}
    </div>
  );
}
